<template>
  <div class="refinements">
    <ais-current-refinements :transform-items="transformItems">
      <div slot-scope="{ items }">
        <ais-clear-refinements v-if="Boolean(items.length)">
          <div slot-scope="{ canRefine, refine, createURL }">
            <a
              class="refinements-clear"
              :href="createURL()"
              v-if="canRefine"
            >
              Reset
            </a>
          </div>
        </ais-clear-refinements>
        <ul class="refinements-list">
          <li
            class="refinements-item"
            v-for="item in items"
            :key="key(item)"
          >
            <button
              class="refinements-button"
              @click.prevent="item.refine(item)"
            >
              {{ item.label }}
              <span aria-hidden="true">
                <close-icon class="refinements-close" />
              </span>
            </button>
          </li>
        </ul>
      </div>
    </ais-current-refinements>
  </div>
</template>

<script>
import flatMap from 'lodash/flatMap';
import CloseIcon from '@/assets/icons/close.svg';

export default {
  components: {
    CloseIcon,
  },
  computed: {
    typeRefinement() {
      // read only from url, because state starts with `null`, and the value is only used on init.
      const match = location.search.match(/type=(restaurant|cinema)/i);

      if (match) {
        // first matching group, if any
        return match[1];
      }
      return undefined;
    },
  },
  methods: {
    key({ attribute, type, value, operator }) {
      return [attribute, type, value, operator].join(':');
    },
    transformItems(items) {
      return flatMap(items, item => {
        if (item.attribute === 'type') {
          const refinement = item.refinements[0];
          if (this.typeRefinement !== refinement.value) {
            return [];
          }
          return [
            {
              ...refinement,
              refine: () => {
                // refine via url since type is set statically.
                location.href = location.href.replace(
                  /type=(restaurant|cinema)/i,
                  ''
                );
              },
            },
          ];
        }

        if (item.attribute === 'availability.available_day') {
          return item.refinements.map(refinement => ({
            ...refinement,
            label: `Available ${refinement.label[0].toLocaleUpperCase()}${refinement.label.slice(
              1
            )}`,
            refine: item.refine,
          }));
        }

        if (item.attribute === 'max_diners') {
          return [
            {
              ...item.refinements[0],
              label: `${item.refinements[0].value} diners`,
              refine: item.refine,
            },
          ];
        }

        if (item.attribute === 'chain') {
          return item.refinements.map(refinement => ({
            ...refinement,
            label:
              refinement.value === 'true'
                ? 'Brand Restaurant'
                : 'Independent Restaurant',
            refine: item.refine,
          }));
        }

        return item.refinements.map(refinement => ({
          ...refinement,
          refine: item.refine,
        }));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.refinements {
  &-clear {
    display: block;
    margin-bottom: 20px;
    @include theme-value(color, brand-color-one);
    text-decoration: none;
    font-weight: 600;
    &:hover {
      text-decoration: underline;
    }
  }
  &-list {
    display: flex;
    margin: 0 -3px;
    flex-wrap: wrap;
  }
  &-item {
    display: flex;
    margin: 0 3px 6px;
  }
  &-button {
    display: flex;
    padding: 6px 8px;
    @include theme-value(background, brand-color-one);
    font-weight: 600;
    font-size: inherit;
    font-family: inherit;
    color: $white;
    text-decoration: none;
    border: none;
    align-items: center;
    position: relative;

    &:hover:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.05);
    }
  }
  &-close {
    height: 9px;
    margin-left: 5px;
    fill: currentColor;
  }
}
</style>
